<template>
    <PopupMain>
        <template #title>Edit angle</template>

        <form id="popup-form" @submit.prevent="formSubmit">
            Change to:
            <input ref="input" v-model="size"/>

            <template v-if="displayControlForHide">
                <br><br>

                <label>
                    Hide angle: <input type="checkbox" v-model="hideAngle">
                </label>
            </template>
        </form>

        <template #footer>
            <button @click="flip">Flip angle</button>

            <button type="submit" form="popup-form">Apply</button>
        </template>
    </PopupMain>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
    import PopupMain from "./PopupMain";

    export default {
        name: "AnglePopup",

        components: {
            PopupMain,
        },

        data() {
            return {
                size: 0,
                centerPointId: null,
                hideAngle: false,
            }
        },

        computed: {
            ...mapState('editPopup', [
                'currentPopup',
            ]),

            ...mapState('editor', [
                'points',
            ]),

            ...mapGetters('editor', [
                'getPointIndexById',
            ]),

            ...mapGetters('line', [
                'getLineByPoints',
            ]),

            ...mapGetters('angles', [
                'getEndPointRotation',
            ]),

            centerPoint() {
                // get an actual center point of the angle by point id from the popup
                let centerPointIndex = this.getPointIndexById(this.centerPointId);

                return this.points[centerPointIndex];
            },

            displayControlForHide() {
                let angle = +this.currentPopup.angle;

                return angle !== 90 && angle !== 180;
            },

        },

        methods: {
            ...mapMutations('angles', [
                'setAngleHidden',
            ]),

            ...mapActions('editPopup', [
                'clearCurrentPopup',
            ]),

            ...mapActions('editor', [
                'setPoints',
            ]),

            ...mapActions('angles', [
                'setAngleChange',
            ]),

            closePopup() {
                this.clearCurrentPopup();
            },

            changeHidden() {
                // set "hidden" to the center point
                let anglePoint = this.points.find(point => +point.id === +this.centerPointId);

                this.setAngleHidden({ anglePoint, hidden: this.hideAngle });
            },

            async formSubmit() {
                // update angle hidden
                this.changeHidden();

                let angleDiff = this.size - this.currentPopup.angle;

                this.setAngleChange({pointCenter: this.centerPoint, angleDiff});

                this.closePopup();
            },

            flip() {
                this.size = 360 - this.size;

                this.formSubmit();
            },

        },

        beforeMount() {
            // to work correctly with the input in the popup,
            // we need to create an internal variable and initialize its value
            this.size = this.currentPopup.angle;
            this.centerPointId = this.currentPopup.centerPoint.id;
            this.hideAngle = this.centerPoint['angleIsHidden'];


        },

        mounted() {
            // input field auto-focus
            this.$refs.input?.focus();
        }

    }
</script>

<style scoped>
    input {
        width: 50px;
    }

    input[type="checkbox"] {
        width: auto;
        margin: auto;
        vertical-align: middle;
    }
</style>